import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { SubscriptionLevel, UserInfo } from 'src/app/auth/models/user';
import { APP_USES_LOGIN } from '../../environments/app-uses-login';
import { AuthenticationService } from '../auth/services/authentication.service';
import { checkCreditCardStatus } from '../_helpers/check-credit-card-expiration';

@Injectable()
export class AuthGuard implements CanActivate {
  user: UserInfo;
  constructor(
    private router: Router,
    @Inject(APP_USES_LOGIN) private appUsesLogin: boolean,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.user = JSON.parse(localStorage.getItem('currentUser'));

    if (this.user) {
      const sessionExpired = new Date() > new Date(this.user.expiresAt);

      if (sessionExpired) {
        this.authenticationService.logout();
        return false;
      }
    }
    const isCCExpired = checkCreditCardStatus(this.user)?.isCCExpired;
    if (
      this.appUsesLogin &&
      this.user?.subscriptionLevel === SubscriptionLevel.STANDARD
    ) {
      if (
        !route.routeConfig.path.includes('myAccount') &&
        this.user?.isMonthlyPaidCustomer
      ) {
        //for standard users
        this.router.navigate(['/accountSettings/myAccount']);
      } else if (!this.user?.isMonthlyPaidCustomer) {
        this.router.navigate(['/login']);
      }
      return true;
    } else if (
      this.appUsesLogin &&
      this.authenticationService.isTrialInvalid(this.user) &&
      this.user?.isMonthlyPaidCustomer &&
      !route.routeConfig.path.includes('myAccount')
    ) {
      //for expired trial users
      this.router.navigate(['/accountSettings/myAccount']);
      return true;
      //check credit card expires only for monthly paid user
    } else if (
      this.appUsesLogin &&
      isCCExpired &&
      this.user?.isMonthlyPaidCustomer &&
      !route.routeConfig.path.includes('myAccount')
    ) {
      //for expired premium users
      this.router.navigate(['/accountSettings/myAccount']);
      return true;
    } else if (
      this.user?.hasBillingIssue &&
      !route.routeConfig.path.includes('myAccount')
    ) {
      this.router.navigate(['/accountSettings/myAccount']);
      return true;
    } else if (!this.appUsesLogin || localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    }
    // not logged in so redirect to landing page with the return url
    this.router.navigate(['/landing'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
